(() => {
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.jdgm-prev-badge, a[href="#judgeme_product_reviews"]');
    const widget = document.getElementById('judgeme_product_reviews');
    if (!trigger || !widget) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const header = document.querySelector('header');
    const offset = (header?.getBoundingClientRect().height || 100) + 32;
    window.scrollTo({top: window.scrollY + widget.getBoundingClientRect().top - offset, behavior: 'auto'});
  }, true);
  function init() {
    const slot = document.querySelector('[data-review-peek]');
    if (!slot) return;
    function populate() {
      const widget = document.getElementById('judgeme_product_reviews');
      if (!widget || widget.dataset.productId !== slot.dataset.productId || slot.dataset.ready) return;
      let sources = [...widget.querySelectorAll('.jdgm-rev__pic-link')].filter(link => {
        const review = link.closest('.jdgm-rev');
        return review?.dataset.productUrl === slot.dataset.productUrl;
      }).slice(0,2);
      if (!sources.length) sources = [...widget.querySelectorAll('.jdgm-gallery__thumbnail[data-review-id]')].slice(0,2);
      if (!sources.length) return;
      slot.dataset.ready = 'true';
      for (const source of sources) {
        const original = source.matches('img') ? source : source.querySelector('img');
        const url = original?.getAttribute('data-src') || original?.getAttribute('src');
        if (!url) continue;
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', source.getAttribute('aria-label') || 'View customer review photo');
        const image = document.createElement('img');
        image.src = url;
        image.alt = original.alt;
        image.width = 64;
        image.height = 64;
        image.loading = 'lazy';
        image.addEventListener('error', () => { button.remove(); if (!slot.querySelector('button')) slot.hidden = true; });
        button.append(image);
        button.addEventListener('click', () => source.click());
        slot.querySelector('.paws-review-peek__photos').append(button);
      }
      slot.hidden = !slot.querySelector('button');
      if (!slot.hidden) observer.disconnect();
    }
    const observer = new MutationObserver(populate);
    observer.observe(document.getElementById('MainContent'), {childList:true,subtree:true});
    populate();
  }
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState === 'complete') init();
})();